import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import MobileTitleSpacer from '../components/MobileTitleSpacer';
import { blogPosts } from '../mockData';
import { useAudio } from '../context/AudioContext';

const Blog = () => {
  const [posts] = useState(blogPosts.filter(post => post.published));

  const { pauseMini, setActivePlayer } = useAudio();

  return (
    <>
      <SEO
        title="Actualités - Charles Ludig"
        description="Découvrez mes derniers projets, et compositions musicales."
        url="https://www.charlesludig.com/actualites"
      />

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="min-h-screen bg-black pt-20 pb-12"
      >
        <div className="container mx-auto px-4 sm:px-6 max-w-7xl">

          {/* Header */}
          <div className="relative py-4 md:py-20 overflow-hidden mb-8 md:mb-12">
            <div
              className="absolute inset-0 opacity-30"
              style={{
                background:
                  "radial-gradient(circle at 30% 50%, rgba(253,214,224,.3) 0%, transparent 70%)",
              }}
            />

            <div className="relative z-10">
              <MobileTitleSpacer height="80px" />

              <h1
                className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white tracking-wider mb-3 md:mb-4"
                style={{ color: "#FDD6E0" }}
              >
                ACTUALITÉS
              </h1>

              <div
                className="h-1 w-32 md:w-40"
                style={{
                  background:
                    "linear-gradient(to right, #FDD6E0, transparent)",
                }}
              />
            </div>
          </div>

          {/* Blog Posts */}
          {posts.length === 0 ? (
            <div className="text-center py-12 md:py-20 px-4">
              <div className="text-5xl md:text-6xl mb-4">📰</div>

              <h3 className="text-xl md:text-2xl font-bold text-white mb-3">
                Actualités à venir
              </h3>

              <p className="text-gray-400 text-sm md:text-base max-w-md mx-auto">
                Restez à l'affût de mes prochains projets, sorties et collaborations.
              </p>
            </div>
          ) : (

            /* 
              MOBILE : mosaïque 2 colonnes
              TABLETTE : 2 colonnes
              DESKTOP : 3 colonnes
            */
            <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6">
              {posts.map((post) => (
                <Link
                  key={post.id}
                  to={`/actualites/${post.slug}`}
                  onClick={() => {
                    pauseMini();
                    setActivePlayer('navigation');
                  }}
                  className="group bg-gray-900 rounded-lg overflow-hidden border border-gray-800 hover:border-[#FDD6E0]/50 transition-all"
                >

                  {/* Image */}
                  {post.image && (
                    <img
                      src={post.image}
                      alt={post.title}
                      loading="lazy"
                      className="w-full h-28 sm:h-36 md:h-48 object-cover transform transition-transform duration-500 group-hover:scale-105"
                    />
                  )}

                  {/* Contenu */}
                  <div className="p-3 sm:p-4 md:p-6">

                    {/* Date */}
                    <div className="text-[10px] sm:text-xs md:text-sm text-[#FDD6E0] mb-1.5 md:mb-2">
                      {new Date(post.created_at).toLocaleDateString('fr-FR', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </div>

                    {/* Titre */}
                    <h3 className="text-sm sm:text-base md:text-xl font-bold text-white mb-1 md:mb-3 leading-tight group-hover:text-[#FDD6E0] transition-colors">
                      {post.title}
                    </h3>

                    {/* 
                      Extrait :
                      caché sur mobile,
                      affiché à partir de md comme avant
                    */}
                    <p className="hidden md:block text-sm md:text-base text-gray-400 mb-3 md:mb-4 line-clamp-3">
                      {post.excerpt}
                    </p>

                  </div>
                </Link>
              ))}
            </div>
          )}

        </div>
      </motion.div>
    </>
  );
};

export default Blog;